import { css } from '@emotion/react'

export const item = ({ isError, isSelected }: { isError?: boolean; isSelected?: boolean }) => css`
  box-sizing: border-box;
  background-color: white;
  padding-bottom: 16px;
  cursor: pointer;
  border: 1px dashed transparent;

  ${isError &&
  css`
    background-color: #ff626266;
    border-color: #d32f2f;
  `}

  ${isSelected &&
  css`
    border-color: #1976d2;
  `}
`

export const itemHeader = css`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
`

export const flexBlock = css`
  display: flex;
  gap: 4px;
  align-items: center;
  padding: 0 10px;
`

export const warningModal = css`
  .MuiPaper-root {
    padding: 24px 16px 16px;

    button {
      margin-top: 16px;
      margin-right: auto;
    }
  }
`
